import React from 'react';
import { GraduationCap, ArrowRight } from 'lucide-react';

const ROLES = [
  {
    id: 'student',
    icon: GraduationCap,
    title: 'Veterinary Student',
    description: 'Currently enrolled in vet school',
    iconColor: 'text-blue-600',
    iconBg: 'bg-blue-50',
    hoverBorder: 'hover:border-blue-300',
    available: true,
  },
];

const RoleSelection = ({ selected, onSelect }) => {
  return (
    <div className="w-full">
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Join Vet Collab</h2>
      <p className="text-gray-500 mb-8 text-sm">Select your professional role to get started</p>

      <div className="space-y-4">
        {ROLES.map(({ id, icon: Icon, title, description, iconColor, iconBg, hoverBorder, available, inviteOnly }) => (
          <button
            key={id}
            type="button"
            disabled={!available}
            onClick={() => available && onSelect(id)}
            className={`
              w-full text-left p-5 rounded-xl border transition-all duration-200 group relative overflow-hidden
              ${selected === id
                ? 'border-indigo-500 bg-white shadow-[0_0_0_1px_rgba(99,102,241,1)]'
                : available
                  ? `border-gray-200 bg-white hover:shadow-sm ${hoverBorder}`
                  : 'border-gray-100 bg-gray-50 opacity-60 cursor-not-allowed'
              }
            `}
          >
            <div className="flex items-center gap-4">
              <div className={`flex-shrink-0 p-3 rounded-full ${iconBg}`}>
                <Icon size={22} className={iconColor} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-gray-900 text-[15px]">{title}</span>
                  {!available && !inviteOnly && (
                    <span className="text-[10px] bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full font-medium flex-shrink-0 uppercase tracking-wider">
                      Coming soon
                    </span>
                  )}
                  {inviteOnly && (
                    <span className="text-[10px] bg-amber-50 text-amber-600 border border-amber-200 px-2 py-0.5 rounded-full font-semibold flex-shrink-0 uppercase tracking-wider">
                      Invite Only
                    </span>
                  )}
                  {selected === id && (
                    <div className="w-5 h-5 rounded-full bg-indigo-500 flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                  )}
                </div>
                <p className="text-sm text-gray-500 mt-0.5 leading-relaxed">{description}</p>
              </div>
            </div>
          </button>
        ))}
      </div>

      <button
        type="button"
        disabled={!selected}
        onClick={() => selected && onSelect(selected, true)}
        className="mt-8 w-full flex items-center justify-center gap-2 py-3 px-6 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all disabled:opacity-40 disabled:cursor-not-allowed shadow-sm"
      >
        Continue
        <ArrowRight size={18} />
      </button>
    </div>
  );
};

export default RoleSelection;
